/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BulkResolveReferenceRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {BulkResolveReferenceResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const bulkResolveReference = (request:BulkResolveReferenceRequest, options?: CashRequestOptions) => post<BulkResolveReferenceRequest, BulkResolveReferenceResponse>("/2.0/cash/bulk-resolve-reference", request, {...options, rejectOnError: true })